import { mergeStyleSets } from '@fluentui/react';

import { DataEnchanter } from '../../../../utils/data-enchanters';

interface IIAISolvedStatusColumn {
    status?: string;
}

interface IIAISolvedStatusColumnClassNames {
    statusIcon: string;
}

export const useClassNames = ({ status }: IIAISolvedStatusColumn): IIAISolvedStatusColumnClassNames => {
    return mergeStyleSets({
        statusIcon: {
            color: DataEnchanter.colorBySolvedStatusEnum(status || ''),
            fontSize: '16px',
            marginRight: '5px'
        }
    });
}